import React from 'react';
import {Parallax, Background} from 'react-parallax';
import CountdownTimer from 'react-awesome-countdowntimer';
import moment from 'moment';
import '../Home.css'
import groovy from "../../../assets/images/groovy.svg";
import BackgroundSlideshow from '../../../components/slideshow/BackgroundSlideshow';
import image1 from '../../../assets/images/1.jpg';
// import image2 from '../../../assets/images/2.jpg';
import image3 from '../../../assets/images/3.jpg';
import image4 from '../../../assets/images/4.jpg';
import image5 from '../../../assets/images/5.jpg';
import image6 from '../../../assets/images/6.jpg';
import logo from '../../../assets/images/logo.svg'
const Event = () => (<div className="event">
    <Parallax
        strength={-240}
        blur={{min: -10, max: 20}}
    >
        <Background>
            <div style={{position: 'relative', width: '100%', height: 950}}>
                <BackgroundSlideshow style={{height: '950', top: 95}} imageDuration={10}
                                     images={[image1, image3, image4, image5, image6]}/>
            </div>

        </Background>
        <div className="conference">
            <div className="conference-header">
                <div className="name">
                    <img src={logo} alt="GR8Conf Europe 2018"/>
                </div>
                <div className="dates">
                    May 30th - June 1st
                </div>
                <div className="where">
                    <strong>Copenhagen</strong>, Denmark
                </div>
                <div className="tag-line">
                    <p>Your source for <br/>
                        <strong>All Things</strong><br/>
                        <img src={groovy} className="groovy-logo" alt="Groovy"/>
                    </p>
                    <p>* with a sprinkle of DevOps</p>
                </div>
            </div>
            <div className="countdown">
                <CountdownTimer endDate={moment('30/05/2018 08:00:00', 'DD/MM/YYYY hh:mm:ss')}/>
            </div>
        </div>
    </Parallax>
</div>);

export default Event;



// WEBPACK FOOTER //
// ./src/pages/home/fragments/Event.js